module.exports = __webpack_public_path__ + "static/media/certificate.e02617d6.svg";